import { MULESOFT_BODY_SHOPS_MOCK_RESPONSE } from "@/components/backoffice/cat/vehicle-assignment/vehicle-bodywork-step/mocks/body-shops.mulesoft.mock";

export function resolveBodyShopLabelFromKvps(
  kvps: string | null | undefined,
): string | null {
  const trimmed = kvps?.trim();
  if (!trimmed) return null;

  const record = MULESOFT_BODY_SHOPS_MOCK_RESPONSE.records.find(
    (row) => row.NoKVPS === trimmed,
  );

  return record?.RaisonSociale.trim() ?? null;
}
